"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { RegistrationRawDataSkeleton } from "@/components/domain/registration/registration-raw-data-skeleton";
import { RawDataDialog } from "@/components/raw-data-dialog";
import { useTRPC } from "@/lib/trpc/client";
interface RegistrationRawDataDialogProps {
  domain: string;
  format: string;
  serverName: string;
  serverUrl: string | undefined;
}

/** Raw-data dialog that fetches the stored RDAP/WHOIS response the first time it opens. */
export function RegistrationRawDataDialog(t0) {
  const $ = _c(15);
  const {
    domain,
    format,
    serverName,
    serverUrl
  } = t0;
  const trpc = useTRPC();
  const [requested, setRequested] = useState(false);
  let t1;
  if ($[0] !== domain || $[1] !== requested || $[2] !== trpc.domain.getRawRegistration) {
    t1 = trpc.domain.getRawRegistration.queryOptions({
      domain
    }, {
      enabled: requested,
      staleTime: Number.POSITIVE_INFINITY
    });
    $[0] = domain;
    $[1] = requested;
    $[2] = trpc.domain.getRawRegistration;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const query = useQuery(t1);
  const t2 = query.data?.rawResponse;
  const t3 = query.isPending && requested ? "loading" : query.isError || query.data === null ? "error" : undefined;
  let t4;
  if ($[4] !== format) {
    t4 = <RegistrationRawDataSkeleton format={format} />;
    $[4] = format;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = open => {
      if (open) {
        setRequested(true);
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== domain || $[8] !== format || $[9] !== serverName || $[10] !== serverUrl || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t6 = <RawDataDialog domain={domain} format={format} data={t2} loadState={t3} loadingFallback={t4} onOpenChange={t5} serverName={serverName} serverUrl={serverUrl} />;
    $[7] = domain;
    $[8] = format;
    $[9] = serverName;
    $[10] = serverUrl;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}